import { render, staticRenderFns } from "./error-layout.vue?vue&type=template&id=81088e06&scoped=true&"
import script from "./error-layout.vue?vue&type=script&lang=ts&"
export * from "./error-layout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81088e06",
  null
  
)

export default component.exports